const isDev = process.env.NEXT_PUBLIC_DEVELOPMENT === 'true';
const AUTH_APP_URL = process.env.NEXT_PUBLIC_AUTH_APP_URL;
const NEXT_PUBLIC_URL = process.env.NEXT_PUBLIC_URL;

export const CDN_IMAGES_URL = process.env.NEXT_PUBLIC_ASSETS_IMAGES_URL;
export const ASSETS_2022_CDN = 'https://d23hwblhugcea5.cloudfront.net';
export const MARKETPLACE_BUCKET_CDN = 'https://d3to9p4w6lww5g.cloudfront.net';
export const WEBSITE_PUBLIC_CDN = `${MARKETPLACE_BUCKET_CDN}/ozone-website-public`;

type ErrorT = {
  default: 'Something went wrong';
  configError: 'Configuration error occurred, please contact Ozone tech support.';
  uploadFileError: 'Error when uploading file';
};

export const SIGN_IN_URL = isDev
  ? 'http://localhost:3001/login?origin=http://localhost:3031/'
  : `${AUTH_APP_URL}/login?origin=${NEXT_PUBLIC_URL}`;

export const SIGN_UP_URL = isDev
  ? 'http://localhost:3001/signUp?origin=http://localhost:3031/'
  : `${AUTH_APP_URL}/signUp?origin=${NEXT_PUBLIC_URL}`;

export const ERROR: ErrorT = {
  default: 'Something went wrong',
  configError:
    'Configuration error occurred, please contact Ozone tech support.',
  uploadFileError: 'Error when uploading file',
};

export const imagePlaceholder =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM88AIAAm4BqjmZp+MAAAAASUVORK5CYII=';

export const prodLinks = {
  studio: 'https://studio.ozonemetaverse.io/',
  marketplace: 'https://marketplace.ozonemetaverse.io/',
  demos: '/worlds',
  worlds: 'https://land.ozonemetaverse.io/',
  docs: 'https://docs.ozonemetaverse.io/',
};

export const IS_PROD =
  process.env.NEXT_PUBLIC_PRODUCTION === 'true' ? true : false;

export const OZONE_TOKEN_WALLET = IS_PROD
  ? '0x256599e1b091be12'
  : '0xff7031050960f704';

export const ADMIN_WALLET_ADDRESS = IS_PROD
  ? '0xd756450f386fb4ac'
  : '0xaef93c7755b965b4';

export const LAND_ADMIN_WALLET_ADDRESS = IS_PROD
  ? '0x256599e1b091be12'
  : '0xba6035b274cbb36d';
